import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { http } from "src/api/http";
import { RevenueOverview } from "@arelia-types/earnings";

export const useEditableTableAPIFactory = (
  apiRoute: string,
  onTotalsRefresh: () => void,
  period: string
) => {
  const [take, setTake] = useState(5);

  const { data: revenueAPIResponse, refetch } = useQuery<RevenueOverview>({
    queryFn: () => http(`${apiRoute}?take=${take}${period ? `&period=${period}` : ''}`),
    queryKey: [apiRoute, take, period]
  });

  const updateDataMutation = useMutation({
    mutationFn: (newData: any[]) => http(`${apiRoute}/bulk`, { method: 'POST', body: newData }),
    onSuccess: () => {
      refetch();
      onTotalsRefresh();
    },
  });

  const deleteDataMutation = useMutation({
    mutationFn: (id: string) => http(`${apiRoute}/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      refetch();
      onTotalsRefresh();
    },
  });

  const getAllData = () => {
    setTake(9999);
  }

  return {
    revenueAPIResponse,
    updateDataMutation,
    deleteDataMutation,
    getAllData
  };
}
